<script setup>
  //
</script>

<template>
  <v-app class="bg-primary">
    <router-view/>
  </v-app>
</template>

<style lang="scss">
@import url('https://fonts.googleapis.com/css2?family=Atkinson+Hyperlegible:ital,wght@0,400;0,700;1,400;1,700&display=swap');
body {
  font-family: 'Atkinson Hyperlegible', Arial, sans-serif;
  font-weight: bold;
}

h1 {
  font-size: 40px;
  line-height: 110%;
}

h2 {
  font-size: 32px;
  line-height: 110%;
}

h3 {
  font-size: 24px;
  line-height: 120%;
}

h4 {
  font-size: 20px;
  line-height: 120%;
}

h5 {
  font-size: 16px;
}

h6 {
  font-size: 14px;
  line-height: 120%;
}

p {
  font-size: 20px;
  font-weight: normal;
  line-height: 140%;
}

.p-small {
  font-size: 16px;
  font-weight: normal;
  line-height: 140%;
}

.p-xsmall {
  font-size: 14px;
  font-weight: bold;
  line-height: 140%;
}

a {
  text-decoration: underline;
  text-underline-offset: 4px;
  color: rgb(var(--v-theme-secondary));

  &:active, &:hover {
    text-decoration: none;
  }
  &:visited {
    color: rgb(var(--v-theme-secondary));
  }
}

.delete-btn {
  color: rgb(var(--v-theme-error));
}

#task-spacer {
  height: 1px;
  border: none;
  background-color: #FFFFFF40
}

@media (min-width: 960px) {
  .text-start-desktop {
    text-align: start !important;
  }
  .tasks-flex-start {
    justify-content: flex-start !important;
  }
}

</style>
